<template>


  <div v-if="store.form.currentStep=== 'stepTwo'">
    <Steps class="mt-4 mt-md-0" @finishStepEmit="finishStepEmit"/>
    <hr class="d-md-none ml-3 mr-3">

    <div class="pl-3 pl-lg-1 pr-4 pt-2 pb-4">
      <form>
        <div class="row">
          <div class="col-12 mt-3 mb-2"
               v-if="this.store.order.seatChoose === 'own' && this.store.order.type === 'order'">
            <div class="custom-control custom-checkbox" style="font-size: 14px;">
              <input class="custom-control-input" v-model="store.form.sameInvoiceAddressOwnSeat"
                     type="checkbox" value="" v-on:change="copySeatAddToInvoiceAdd"
                     id="checkSameAddress">
              <label class="custom-control-label" for="checkSameAddress">
                {{ t('personalForm.stejnaFakturacniAdresa') }}
              </label>
            </div>
          </div>
          <div class="col-6 col-md-6">
            <InputText v-model="store.order.contactInfo.firstName" label-name="personalForm.firstName" id="firstName"
                       required="personalForm.required.jmeno" step="stepTwo"/>
          </div>
          <div class="col-6 col-md-6">
            <InputText v-model="store.order.contactInfo.surName" label-name="personalForm.surName" id="surName"
                       required="personalForm.required.prijmeni" step="stepTwo"/>
          </div>
          <div class="col-12 col-md-6">
            <InputEmail InputText v-model="store.order.contactInfo.email" label-name="personalForm.email" id="email"
                        required="personalForm.required.email" step="stepTwo"/>
          </div>
          <!--          <div class="col-12 col-md-6">-->
          <!--            <div class="row">-->

          <!--              <div-->
          <!--                  :class="[store.order.contactInfo.phoneCountry.value === 'other' ? 'col-2 col-md-4 col-lg-3' : 'col-4 col-md-6']">-->
          <!--                <div class="dropdown jake-dropdown">-->
          <!--                  <span class="label">{{ t('personalForm.phone') }}</span>-->
          <!--                  <a class=" dropdown-toggle" href="#" role="button" id="dropdownPhone" data-toggle="dropdown"-->
          <!--                     aria-expanded="false">-->
          <!--              <span v-if="store.order.contactInfo.phoneCountry">-->

          <!--      <img v-if="store.order.contactInfo.phoneCountry.iconFile"-->
          <!--           width="20" style="vertical-align: text-bottom"-->
          <!--           v-bind:src="store.order.contactInfo.phoneCountry.iconFile" alt=""/>-->

          <!--                {{ store.order.contactInfo.phoneCountry.text }}-->
          <!--              </span>-->
          <!--                  </a>-->

          <!--                  <div class="dropdown-menu shadow" aria-labelledby="dropdownPhone">-->
          <!--                <span class="dropdown-item cursorLink" v-for="item in form.phoneCoutries"-->
          <!--                      @click="setPhoneCountry(item)">-->
          <!--         <img v-if="item.iconFile" width="20" style="vertical-align: text-bottom"-->
          <!--              v-bind:src="item.iconFile" alt=""/>-->
          <!--                  {{ item.text }}-->
          <!--                </span>-->

          <!--                  </div>-->
          <!--                </div>-->


          <!--              </div>-->

          <!--              <div class="col-3 col-md-3 pl-0 pr-0" v-if="store.order.contactInfo.phoneCountry.value === 'other'">-->
          <!--                <InputNumber-->
          <!--                    v-model="store.order.contactInfo.phoneCountryCustom"-->
          <!--                    label-name="personalForm.phoneCountryCustom" id="phoneCountryCustom"-->
          <!--                    required="Prosím vyplňte předvolbu " step="stepTwo"/>-->

          <!--              </div>-->
          <!--              <div class="col-7 col-md-6"-->
          <!--                   :class="[store.order.contactInfo.phoneCountry.value === 'other' ? 'col-6 col-md-6' : 'col-8 col-md-6']">-->
          <!--                <InputPhoneNumber v-model="store.order.contactInfo.phone" label-name="" id="tel"-->
          <!--                                  required="Prosím vyplňte telefon " step="stepTwo"/>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->

          <!--          INPUT PHONE START-->
          <div class="col-12 col-md-6">
            <div class="row">
              <div
                  :class="[store.order.contactInfo.phoneCountry.value === 'other' ? 'col-2 col-md-4 col-lg-4' : 'col-4 col-md-5']">
                <div class="dropdown jake-dropdown">
                  <!--                  <span class="label">{{ t('personalForm.phone') }}</span>-->
                  <a class=" dropdown-toggle" href="#" role="button" id="dropdownPhone" data-toggle="dropdown"
                     aria-expanded="false" v-on:click="dropdownCheck">
              <span v-if="store.order.contactInfo.phoneCountry">

      <img v-if="store.order.contactInfo.phoneCountry.iconFile"
           width="20" style="width: 20px!important; vertical-align: text-bottom"
           v-bind:src="store.order.contactInfo.phoneCountry.iconFile" alt=""/>

                {{ store.order.contactInfo.phoneCountry.text }}
              </span>
                  </a>

                  <div class="dropdown-menu" ref="dropdownPhone" aria-labelledby="dropdownPhone">
                <span class="dropdown-item cursorLink" v-for="item in form.phoneCoutries"
                      @click="setPhoneCountry(item)">
         <img v-if="item.iconFile" width="20" style="width: 20px!important;vertical-align: text-bottom"
              v-bind:src="item.iconFile" alt=""/>
                  {{ item.text }}
                </span>

                  </div>
                </div>


              </div>
              <div class="col d-flex">
                <InputPhoneNumber v-model="store.order.contactInfo.phone" label-name="personalForm.phone" id="tel"
                                  required="personalForm.required.tel" step="stepTwo"/>
              </div>
            </div>
          </div>
          <!--INPUT PHONE END-->

          <div class="col-12 col-md-6" v-if="store.order.type === 'order'">
            <InputText v-model="store.order.contactInfo.street" label-name="personalForm.street" id="street"
                       required="personalForm.required.ulice"
                       step="stepTwo"
                       :tip="profile.showAddressHint ? 'streetAndHouse' : null"/>
          </div>
          <div class="col-6 col-md-6" v-if="store.order.type === 'order'">
            <InputText v-model="store.order.contactInfo.city" label-name="personalForm.city" id="city"
                       required="personalForm.required.obec" step="stepTwo"/>
          </div>
          <div class="col-6 col-md-6" v-if="store.order.type === 'order'">

            <div class="form-label-group mb-1">
              <input type="text" id="postCode" class="form-control"
                     :class="{'is-invalid': isBlurred() && !store.order.contactInfo.psc}"
                     v-model="store.order.contactInfo.psc"
                     v-on:input="preventPscInputFromLetter"
                     v-on:change="store.pscFilterInvoice()"
                     placeholder="{{ t('personalForm.psc') }}"
                     required=""/>
              <label for="postCode"> {{ t('personalForm.psc') }}</label>
              <div id="validationServer05Feedback" class="invalid-feedback">
                {{ t('personalForm.required.psc') }}
              </div>
            </div>


          </div>
          <div class="col-12 col-md-6" v-if="store.order.type === 'order'">

            <div class="dropdown jake-dropdown mb-3" v-if="store.order.contactInfo.country.value !== 'others'">
              <span class="label">{{ t('personalForm.country') }}</span>
              <a class=" dropdown-toggle" href="#" role="button" id="dropdownPhone" data-toggle="dropdown"
                 aria-expanded="false">
              <span v-if="store.order.contactInfo.country">

                {{ t('personalForm.countries.' + store.order.contactInfo.country.value) }}
              </span>
              </a>

              <div class="dropdown-menu shadow" aria-labelledby="dropdownPhone">
                    <span class="dropdown-item-text text-uppercase text-muted">
            <small>Vyberte zemi</small></span>
                <span class="dropdown-item cursorLink" v-for="item in form.countries"
                      @click="setCountry(item)">
         <img v-if="item.iconFile" width="20" style="vertical-align: text-bottom"
              v-bind:src="item.iconFile" alt=""/>
                  {{ t('personalForm.countries.' + item.value) }}
                </span>

              </div>
            </div>
            <div class="position-relative">
              <InputText v-if="store.order.contactInfo.country &&store.order.contactInfo.country.value === 'others'"
                         v-model="store.order.contactInfo.otherCountry" label-name="personalForm.country"
                         id="otherCountry"
                         :required="t('personalForm.required.country')" step="stepTwo"/>
              <span v-if="store.order.contactInfo.country.value === 'others'" class="clearButton"
                    v-on:click="selectCzechCountry"><i
                  class="fa fa-times"></i> </span>
            </div>
          </div>


          <!--          <div class="col-12 col-md-6" v-if="store.order.type === 'order'">
                      <InputText v-model="store.order.contactInfo.country" label-name="personalForm.country" id="country"
                                 required="Prosím vyplňte zemi" step="stepTwo"/>
                    </div>-->

          <div class="col-12 col-md-6" v-if="store.order.type === 'order'">
            <div class="dropdown jake-dropdown mb-3">
          <span class="label">{{ t('personalForm.healthInsurance') }}
            <!--            <Tooltip-->
            <!--                title="zdravotniPojistovna"/>-->
          </span>
              <a class="dropdown-toggle" href="#"
                 role="button" id="dropdownHealth" data-toggle="dropdown"
                 aria-expanded="false"
                 :class="{'is-invalid' : isBlurred() && !store.order.healthInsurance}">
              <span v-if="store.order.healthInsurance">
              {{ t('personalForm.healthInsurances.' + store.order.healthInsurance) }}
               </span>
                <span v-else>
            {{ t('personalForm.chooseHealthInsurance') }}
          </span>
              </a>
              <span v-if="store.order.healthInsurance" class="clearButton" v-on:click="clearHealthInsurance"><i
                  class="fa fa-times"></i> </span>


              <div class="dropdown-menu shadow" aria-labelledby="dropdownHealth">
          <span class="dropdown-item-text text-uppercase text-muted">
            <small>
           {{ t('personalForm.chooseHealthInsurance') }}</small></span>
                <a class="dropdown-item"
                   :class="{'text-secondary': item === store.order.healthInsurance}"
                   href="#" v-for="item in form.healthInsurance"
                   @click.prevent="setHealthInsurance(item)">
                  {{ t('personalForm.healthInsurances.' + item) }}
                </a>

              </div>
              <div v-if="isBlurred() && !store.order.healthInsurance"
                   class="small error-block text-danger mt-1">{{ t('personalForm.required.healthInsurance') }}
              </div>
              <div v-if="wasFlatRateTaxUnselected" class="insurance-info-block" style="background-color: #FEE7E9">
                <div class="icon">
                  <i class="fa-solid fa-exclamation"></i>
                </div>
                <div class="text">
                  <div v-html="t('errorInput.FlatRateTaxUnselected')"/>
                </div>
              </div>


            </div>
          </div>
          <div class="col-12 col-md-6" v-if="store.order.type === 'order'">
            <div class="dropdown jake-dropdown">
              <span class="label">{{ t('payment.paymentType') }}</span>
              <a class=" dropdown-toggle" :class="{'is-invalid' : isBlurred() && !store.order.paymentType}" href="#"
                 role="button" id="dropdownPayment" data-toggle="dropdown"
                 aria-expanded="false">
              <span v-if="store.order.paymentType">
              {{ t(store.order.paymentType) }}
              </span>
                <span v-else>
            {{ t('payment.callToActionText') }}

          </span>
              </a>
              <span v-if="store.order.paymentType" class="clearButton" v-on:click="clearPaymentType"><i
                  class="fa fa-times"></i> </span>

              <div class="dropdown-menu shadow" aria-labelledby="dropdownHealth">
          <span class="dropdown-item-text text-uppercase text-muted">
            <small>{{ t('payment.callToActionText') }}</small></span>
                <a class="dropdown-item" href="#" v-for="item in form.paymentsTypes"
                   :class="{'text-secondary': item === store.order.paymentType}"
                   @click.prevent="setPaymentType(item)">
                  {{ t(item) }}
                </a>

              </div>
              <div v-if="isBlurred() && !store.order.paymentType"
                   class="small error-block text-danger mt-1">{{ t('payment.required') }}
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6"></div>
          <div class="col-12 col-md-7 ml-auto mt-4 mb-4 text-right" style="font-size: 14px">
            <div class="custom-control custom-checkbox">
              <input class="custom-control-input" :class="{'is-invalid': isBlurred() && !store.order.checkAgreement}"
                     v-model="store.order.checkAgreement" type="checkbox" value=""
                     id="checkAgreement">
              <label class="custom-control-label" for="checkAgreement">
                {{ t('agreement.agreementWith') }}
                <a :href="t('agreement.privacyPolicyUrl')"
                   target="_blank">
                  {{ t('agreement.personalInformations') }}</a>
                <span v-if="store.order.type === 'order'">
            <br class="d-none d-md-inline">
            {{ t('agreement.andWith') }}
            <a :href="t('agreement.termsAndConditionsUrl')" target="_blank">
              {{ t('agreement.obchodniPodminky') }}</a>
              </span>
              </label>
              <div v-if="isBlurred() && !store.order.checkAgreement" class="invalid-feedback">
                <span v-if="store.order.type === 'order'">{{ t('agreement.required') }}</span>
                <span v-else>{{ t('agreement.requiredDemand') }}</span>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div v-if="demandError" class="small font-weight-bold error-block text-danger mb-2 text-center text-md-right pr-md-3" role="alert">
        {{ t('submitError') }}
      </div>
      <div class="row">
        <div class="col-12 col-md-5 px-0 px-md-3 order-last order-md-first text-center text-md-left">
          <div class="px-3">
            <hr class="d-md-none mt-0">
          </div>
          <NeedHelp/>
        </div>
        <div class="col-12 col-md-7 pb-4 text-right d-none d-md-block">
          <button class="btn btn-primary mr-3" type="button" @click='previousStep'> {{ t('btn.zpet') }}</button>
          <button v-if="store.order.type === 'order'" class="btn btn-secondary px-4" type="button" @click='nextStep'>
            <span v-html="sendingSpinnerNextStep"/>
            {{ t('btn.pokracovat') }}
          </button>
          <button v-if="store.order.type === 'demand'" class="btn btn-secondary px-4" type="button" @click='sendDemand'>
            <span v-html="sendingSpinner"/> {{ t('btn.odeslatPoptavku') }}
          </button>
        </div>
        <div class="col-12 col-md-7 pb-4 text-right d-md-none">
          <div class="row">
            <div class="col-3 text-left">
              <button class="btn btn-sm btn-primary mr-sm-3" type="button" @click='previousStep'> {{ t('btn.zpet') }}
              </button>
            </div>
            <div class="col">
              <button v-if="store.order.type === 'order'" class="btn btn-sm btn-secondary px-4" type="button"
                      @click='nextStep'>
                <span v-html="sendingSpinnerNextStep"/>
                {{ t('btn.pokracovat') }}
              </button>
              <button v-if="store.order.type === 'demand'" class="btn btn-sm btn-secondary px-4" type="button"
                      @click='sendDemand'><span v-html="sendingSpinner"/>
                {{ t('btn.odeslatPoptavku') }}
              </button>

            </div>
          </div>

        </div>


      </div>
    </div>
  </div>

</template>

<script lang="ts">
import {useI18n} from "vue-i18n";
import {useLocaleProfile} from "@/composables/useLocaleProfile";
import {useProductName} from "@/composables/useProductName";
import * as Sentry from "@sentry/vue";
import {ref} from 'vue'
import InputText from "../FormsInputs/inputText.vue";
import InputEmail from "../FormsInputs/inputEmail.vue";
import InputNumber from "../FormsInputs/inputNumber.vue"
import InputPscNumber from "../FormsInputs/inputPscNumber.vue"

import Tooltip from "../others/Tooltip.vue";
import {store} from "../store.js";


import flagCz from '@/assets/imgs/flags/cz.png';
import flagDe from '@/assets/imgs/flags/de.png';
import flagFr from '@/assets/imgs/flags/fr.png';
import flagGb from '@/assets/imgs/flags/gb.png';
import flagPl from '@/assets/imgs/flags/pl.png';
import flagSk from '@/assets/imgs/flags/sk.png';
import NeedHelp from "../others/NeedHelp.vue";
import Steps from "../others/StepsComponent/Steps.vue";
import InputPhoneNumber from "@/components/FormsInputs/inputPhoneNumber.vue";
import * as EmailValidator from 'email-validator';
import {TradeDemand} from "@/model/SwissDemand";
import {DemandType} from "../../model/SwissDemand";


export default {
  name: "StepTwo",
  props: ['currentStep'],
  components: {Steps, NeedHelp, InputText, InputEmail, InputNumber, InputPhoneNumber, InputPscNumber, Tooltip},
  setup() {
    const {t, locale} = useI18n({useScope: 'global'})
    const {profile} = useLocaleProfile()
    const {orderItemName} = useProductName()
    const select = ref(0)
    const lang = locale;
    return {t, select, lang, profile, orderItemName}
  },
  data() {
    return {
      errors: [],
      store,
      soc: store.order.contactInfo,
      nextStepSending: false,
      demandError: false,
      wasFlatRateTaxUnselected: false,
      form: {
        phoneCoutries: [
          {
            value: '420',
            text: '+ 420',
            iconName: 'cz.png',
            iconFile: flagCz
          },
          {
            value: '421',
            text: '+ 421',
            iconName: 'sk.png',
            iconFile: flagSk
          },
          {
            value: '49',
            text: '+ 49',
            iconName: 'de.png',
            iconFile: flagDe
          },
          {
            value: '48',
            text: '+ 48',
            iconName: 'pl.png',
            iconFile: flagPl

          },
          {
            value: '44',
            text: '+ 44',
            iconName: 'gb.png',
            iconFile: flagGb
          },
          {
            value: '33',
            text: '+ 33',
            iconName: 'fr.png',
            iconFile: flagFr
          },
          {
            value: 'other',
            text: this.t('personalForm.phoneCountryCustomCode'),
            iconName: null
          },


        ],
        countries: [
          {
            value: 'czechia',
            iconName: 'cz.png',
            iconFile: flagCz,
            code: 'CZ'
          },
          {
            value: 'slovakia',
            iconName: 'sk.png',
            iconFile: flagSk,
            code: 'SK'
          },
          {
            value: 'germany',
            iconName: 'de.png',
            iconFile: flagDe,
            code: 'DE'
          },
          {
            value: 'polish',
            iconName: 'pl.png',
            iconFile: flagPl,
            code: 'PL'

          },
          {
            value: 'greatBritain',
            iconName: 'gb.png',
            iconFile: flagGb,
            code: 'GB'
          },
          {
            value: 'france',
            iconName: 'fr.png',
            iconFile: flagFr,
            code: 'FR'
          },
          {
            value: 'others',
            iconName: null,
            code: null
          },


        ],
        healthInsurance:
            ['none',
              '111',
              '201',
              '205',
              '207',
              '209',
              '211',
              '213'],
        paymentsTypes: ['payment.card', 'payment.bank']
      },

    }
  },
  methods: {
    isBlurred() {
      return this.store.form.steps.stepTwo.blurred;
    },

    finishStepEmit(name) {
      //console.log(`hello world`);
      this.nextStep();
    },


    checkStep() {
      console.log('Starting check step')
      var order = this.store.order;
      this.store.form.steps.stepTwo.filled = false;
      if (store.order.type === 'order') {
        console.log('Type order');
        if (!order.contactInfo.firstName) return false;
        if (!order.contactInfo.surName) return false;
        if (!order.contactInfo.email) return false;
        if (!order.contactInfo.phone) return false;
        if (!order.contactInfo.street) return false;
        if (!order.contactInfo.city) return false;
        if (!order.contactInfo.psc) return false;
        if (!order.contactInfo.country) return false;
        if (!order.paymentType) return false;
        if (!order.healthInsurance) return false;
      } else if (store.order.type === 'demand') {
        console.log('Type demand');
        if (!order.contactInfo.firstName) return false;
        if (!order.contactInfo.surName) return false;
        if (!order.contactInfo.email) return false;
        if (!order.contactInfo.phone) return false;
      }

      if (!this.checkEmail()) return false;
      if (!order.checkAgreement) return false;
      // if (order.contactInfo.phoneCountry.value === 'other' && !order.contactInfo.phoneCountryCustom) return false;
      if (!order.contactInfo.phone || order.contactInfo.phone.replaceAll(' ', '').length < 9) return false;

      return true;

    },

    async nextStep() {
      this.store.form.steps.stepTwo.blurred = true;
      this.nextStepSending = true;
      var check = this.checkStep();
      // console.log('check: ' + check);
      if (check) {
        await this.sendUnfinishedLeadOrder();
        this.store.form.steps.stepTwo.visited = true;
        this.store.form.steps.stepTwo.filled = true;
        this.nextStepSending = false;
        this.store.form.currentStep = 'stepThree';
        this.store.tradeClarityEvent('before-order-finish');
        this.store.vueClarityEvent('before-order-finish');
        this.store.gaEventNextStep('step3')
        this.store.scrollTop();
      } else {
        this.$nextTick(() => {
          this.nextStepSending = false;
          this.store.scrollToErrorInput();
        })
      }

    },
    async sendUnfinishedLeadOrder() {
      console.log('sendUnfinishedOrderLead');
      // pokud je eaynetLeadId tak už byl unfinished lead order odeslán.
      let url = "";
      if (this.store.order.raynetLeadId)
        url = this.store.urls.jakeSwissUrl + '/raynet/update-lead/';
      else
        url = this.store.urls.jakeSwissUrl + '/raynet/create-lead/';

      var data = this.prepareData(true);
      var config = {
        method: 'post',
        url: url,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      return await this.axios.post(config.url, config.data, config.headers)
          .then(response => {
            //console.log('Odeslán nedokončený lead', response);
            this.store.order.raynetLeadId = response.data.data.data.id;
            console.log('raynetLeadId', this.store.order.raynetLeadId);
            return true;
          })
          .catch(function (error) {
            console.log('Chyba odeslání nedokončeného leadu', error);
            return false;
          });

    },
    sendDemand() {
      if (!this.store.form.formSending) {
        this.store.form.formSending = true;
        this.demandError = false;
        this.store.form.steps.stepTwo.blurred = true;
        var check = this.checkStep();
        // console.log('check: ' + check);
        if (check) {
          //console.log('Odesílám poptávku');
          try {
            if (!this.store.debug)
              this.store.gaEventFinishForm();
            this.store.tradeClarityEvent('finish-demand');
            this.store.vueClarityEvent('finish-demand');
          } catch (e) {
            console.error(e);
          }
          this.sendLead();
        } else {
          this.store.form.formSending = false;
          this.$nextTick(() => {
            this.store.scrollToErrorInput();
          })
        }

      }

    },
    finishDemand() {
      this.store.form.formSending = false;
      this.store.form.formSucceed = true;
      this.store.form.steps.stepTwo.visited = true;
      this.store.form.steps.stepTwo.filled = true;
      this.store.form.currentStep = 'stepFour';

      this.store.scrollTop();

    },


    // lead
    sendLead() {

      let data;
      try {
        data = this.prepareData();
      } catch (error) {
        this.errorDemand(error);
        return;
      }
      console.log('lead data:', data);
      var config = {
        method: 'post',
        url: this.store.urls.jakeSwissUrl + '/demand/create-lead/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      this.axios.post(config.url, config.data, config.headers)
          .then(response => {
            this.finishDemand();
          }, error => {
            this.errorDemand(error);
          });
    },
    errorDemand(error) {
      console.error('Chyba odeslání poptávky', error);
      // výpadek sítě (bez response) do Sentry neposílat, každá chyba spouští replay a free plán jich má 50/měsíc
      if (!error?.isAxiosError || error.response) {
        Sentry.withScope((scope) => {
          scope.setTag('demand-submit', 'true');
          Sentry.captureException(error);
        });
      }
      this.demandError = true;
      this.store.form.formSending = false;
    },
    prepareData(typeOrder = false) {
      var o = this.store.order;

      if (typeOrder) {
        var data = {
          "type": "orderTrade",
          "leadId": o.raynetLeadId ? String(o.raynetLeadId) : null,
          "email": o.contactInfo.email,
          "phone": store.getFormattedPhoneNumber(),
          "sourceUrl": window.location.href,
          "sourceWeb": window.location.host,
          "currency": this.store.form.currency,
          "items": this.prepareProducts(),
          "addresses": this.prepareAddresses(),
          "lang": this.store.form.language,
          "totalPriceWithVat": String(this.store.calcOrderTotalPriceWithVat()),
          "totalPriceWithoutVat": String(this.store.calcOrderTotalPriceNoVat()),
          "orderNote": this.prepareOrderNote(),
        }
        //  console.log(data)
        return data;
      } else {
        //demand
        let demandData: TradeDemand = {
          "type": DemandType.TRADE,
          "email": o.contactInfo.email,
          "phone": store.getFormattedPhoneNumber(),
          "note": "", // nemáme poznámku!
          "firstName": o.contactInfo.firstName,
          "lastName": o.contactInfo.surName,
          "faStreet": "",
          "faCountry": "",
          "faZipCode": "",
          "sourceUrl": window.location.href,
          "sourceWeb": window.location.host,
          "currency": this.store.form.currency,
          "products": this.prepareProducts(),
          "lang": this.store.form.language,
          "totalPriceWithVat": String(this.store.calcOrderTotalPriceWithVat()),
          "totalPriceWithoutVat": String(this.store.calcOrderTotalPriceNoVat()),
          "tradeName": o.oborZivnosti,
          "tradeType": o.cinnost,
          "taxReturn": o.taxReturnPreparationService,
          "taxRegistration": o.regstrationToFlatRateTax,
          "ownSeatStreet": o.ownSeatAddress.street,
          "ownSeatCity": o.ownSeatAddress.city,
          "ownSeatZipCode": o.ownSeatAddress.psc,
          "ownSeatCountry": o.ownSeatAddress.country,
          "residency": o.residency,
          "economicActivity": o.economicActivity,
          "personalInformationAgreement": o.checkAgreement,
        }
        return demandData;
      }
    },

    prepareAddresses() {
      var o = this.store.order;
      var arrayAdd = [];

      var invoiceAdd = {
        "firstName": o.contactInfo.firstName,
        "lastName": o.contactInfo.surName,
        "street": o.contactInfo.street,
        "city": o.contactInfo.city,
        "country": o.contactInfo.country.code,
        "postCode": o.contactInfo.psc,
        "addressType": "invoice",
      }
      //  console.log(invoiceAdd);
      arrayAdd.push(invoiceAdd)
      return arrayAdd;
    },
    prepareProducts() {
      var prodArray = [];
      this.store.order.products.forEach((item) => {
        console.log(item);

        // zu01 hack
        if (item.code === 'ZU01') {
          const zu01Price = store.getPriceSpravniPoplatek(); // místo item.standardPrice kvůli EN verzi
          item.totalPriceWithVat = zu01Price * store.getVatForProduct(item);
          item.totalPriceWithoutVat = zu01Price;
          item.totalPriceWithoutVatFilter = store.priceFilter(item.totalPriceWithoutVat);
          item.totalPriceWithVatFilter = store.priceFilter(item.totalPriceWithVat);
        }


        var amount = 1;
        var totalPriceWithVat = item.totalPriceWithVat
        var totalPriceWithoutVat = item.totalPriceWithoutVat
        var totalPriceWithoutVatFormatted = item.totalPriceWithoutVatFilter;
        var totalPriceWithVatFormatted = item.totalPriceWithVatFilter;
        if (item.type === 'seat') {
          amount = item.months;
          totalPriceWithVat = item.totalPriceWithVat / amount;
          totalPriceWithoutVat = item.totalPriceWithoutVat / amount;
          totalPriceWithoutVatFormatted = store.priceFilter(totalPriceWithoutVat);
          totalPriceWithVatFormatted = store.priceFilter(totalPriceWithVat);
        }

        var arItem = {
          "type": item.type,
          "name": this.orderItemName(item),
          "code": item.code,
          "amount": amount,
          "priceWithVat": String(totalPriceWithVat),
          "priceWithoutVat": String(totalPriceWithoutVat),
          "priceWithoutVatFormatted": totalPriceWithoutVatFormatted,
          "priceWithVatFormatted": totalPriceWithVatFormatted,
          "vatRate": item.vatRateId,
          "amountUnit": item.unit,
          "jakeIsId": item.id
        };
        prodArray.push(arItem);

      });
      // console.log(prodArray);
      return prodArray;
    },

    prepareOrderNote() {
      // podrobnosti objednávky pro lead
      var o = this.store.order;
      var oNote = '<b>Souhrn:</b> <br>';
      oNote += this.t('sendOrder.oborZivnosti') + ': ' + o.oborZivnosti + ', <br>';
      if (this.profile.askTradeType) // typ činnosti
        oNote += this.t('sendOrder.cinnost') + ': ' + this.t('sendOrder.values.' + o.cinnost) + ', <br>';
      else if (this.profile.askResidency) {
        oNote += 'Rezidence : ' + this.t('souhrn.residency.' + o.residency) + '<br>';
        oNote += 'Ekonomická činnost : ' + this.t('souhrn.economicActivity.' + o.economicActivity) + '<br>';
      }
      if (o.healthInsurance) oNote += this.t('sendOrder.healthInsurance') + ': ' + this.t('personalForm.healthInsurances.' + o.healthInsurance) + ', <br>';
      if (o.checkAgreement) oNote += this.t('sendOrder.checkAgreement') + ': ' + this.t('sendOrder.values.' + o.checkAgreement) + ', <br>';
      // oNote += this.t('sendOrder.customerWantNextServices') + ': ' + this.t('sendOrder.values.' + o.customerWantNextServices) + ', <br>';
      oNote += this.t('sendOrder.regstrationToFlatRateTax') + ': ' + this.t('sendOrder.values.' + o.regstrationToFlatRateTax) + ', <br>';

      if (this.profile.offerTaxReturnService) // služba zpracování daňového přiznání
        oNote += this.t('sendOrder.taxReturnPreparationService') + ': ' + this.t('sendOrder.values.' + o.taxReturnPreparationService) + ', <br>';


      // vlastni adresa sidla
      if (o.seatChoose === 'own') oNote += '<br> <b>Adresa vlastního sídla:</b> <br> Ulice: ' + o.ownSeatAddress.street
          + ',<br> PSČ: ' + o.ownSeatAddress.psc
          + ',<br> Město: ' + o.ownSeatAddress.city
          + ',<br> Země: ' + o.ownSeatAddress.country + '<br> <br>';

      oNote += '<br> Produkty: <br>'
      o.products.forEach(element => {
        if (this.profile.pricing === 'standard') {
          if (element.type === 'seat') oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.totalPriceWithoutVat + ' Kč bez DPH <br>'
          else oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.standardPrice + ' Kč bez DPH <br>'
        } else {
          if (element.type === 'seat') oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.totalPriceWithoutVatFilter + ' bez DPH <br>'
          else if (element.code === 'ZU01')
            oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + this.store.priceFilter(this.store.getPriceSpravniPoplatek()) + '<br>'
          else oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.totalPriceWithoutVatFilter + ' bez DPH <br>'
        }
      });

      return oNote;
    },

    checkEmail() {
      var email = this.store.order.contactInfo.email;
      return EmailValidator.validate(email);
    },

    setPhoneCountry(item) {
      this.store.order.contactInfo.phoneCountry = item;
      store.lettersInPhoneNumberInput();
    },
    setCountry(item) {
      this.store.order.contactInfo.country = item;
    },
    setHealthInsurance(item) {
      this.store.order.healthInsurance = item;
      if (item === 'none' && this.store.order.regstrationToFlatRateTax) {
        this.store.order.regstrationToFlatRateTax = false;
        this.wasFlatRateTaxUnselected = true;
      } else {
        this.wasFlatRateTaxUnselected = false;
      }
    },
    setPaymentType(item) {
      this.store.order.paymentType = item;
    },
    clearHealthInsurance() {
      if (this.store.order.healthInsurance.length > 0) this.store.order.healthInsurance = '';

    },
    clearPaymentType() {
      if (this.store.order.paymentType.length > 0) this.store.order.paymentType = '';

    },

    previousStep() {
      //this.store.form.steps.stepOne.filled = false;
      //this.store.form.currentStep = 'stepOne';
      this.store.previousStep();
    },

    copySeatAddToInvoiceAdd() {
      if (store.form.sameInvoiceAddressOwnSeat) {
        this.store.pscFilter();
        var add = this.store.order.contactInfo;
        var inv = this.store.order.ownSeatAddress;
        add.psc = inv.psc
        add.street = inv.street
        add.city = inv.city

        this.selectCzechCountry();
      }

    },

    selectCzechCountry() {
      var countries = this.form.countries.filter(function (elem) {
        if (elem.value === "czechia") return elem;
      });
      this.store.order.contactInfo.country = countries[0];
    },

    // nastaveni defaultni hodnoty pro phone input dle mutace (viz src/localeProfiles.js)
    setDefaultPhoneCountry() {
      var prefix = this.profile.defaultPhonePrefix;
      var phoneCountries = this.form.phoneCoutries.filter(function (elem) {
        return elem.value === prefix;
      });
      this.store.order.contactInfo.phoneCountry = phoneCountries[0];
    },

    preventPscInputFromLetter() {
      store.order.ownSeatAddress.psc = store.order.ownSeatAddress.psc.replace(/\D/g, '').substring(0, 5);
    }
  },
  watch: {
    'store.form.currentStep'() {
      this.demandError = false;
    },
  },
  computed: {
    sendingSpinner() {
      if (this.store.form.formSending) {
        return '<img width="20" style="margin-left:-10px; margin-right: 5px;" src="/assets/jake-style/imgs/loading/loading.svg"/> ';
      } else return '';
    },
    sendingSpinnerNextStep() {
      if (this.nextStepSending) {
        return '<img width="20" style="margin-left:-10px; margin-right: 5px;" src="/assets/jake-style/imgs/loading/loading.svg"/> ';
      } else return '';
    }
  },
  created() {
    this.setDefaultPhoneCountry();

    // nastaveni defaultni hodnoty pro country
    this.selectCzechCountry();

    // Debug prepinac jazyka v App.vue meni locale za behu — predvolba se prepne s nim.
    // V sestavenem balicku se locale nemeni, takze se watch nikdy nespusti.
    this.$watch('profile', () => this.setDefaultPhoneCountry());


  },

}


</script>

<style lang="scss" scoped>
.clearButton {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  //border: 1px solid red;
  text-align: center;
  top: 24px;
  right: 0px;
  font-size: 12px;
  z-index: +1000;
  cursor: pointer;

}
</style>